import { useState } from 'react';
import { Box } from '@chakra-ui/react';
import { AnimatePresence, motion } from 'framer-motion';

import { ChevronDownIcon, ChevronUpIcon } from 'Asset/icon';
import { Condition } from 'Component/others';

import { dropdownAnimation } from 'View/host-presence-content/helpers/dropdownAnimation';

import styles from './styles.module.css';

const Accordion = ({ header, children, defaultOpen = false }) => {
  const [isOpen, setIsOpen] = useState(defaultOpen);

  return (
    <Box className={styles['accordion__container']}>
      <Box className={styles['accordion__header']} onClick={() => setIsOpen(!isOpen)}>
        <Box className={styles['accordion__header-content']}>{header}</Box>
        <Condition statement={isOpen} fallback={<ChevronDownIcon size={20} />}>
          <ChevronUpIcon size={20} />
        </Condition>
      </Box>
      <AnimatePresence initial={false}>
       <Condition statement={isOpen}>
          <motion.div {...dropdownAnimation}>
            <Box className={styles['accordion__content']}>{children}</Box>
          </motion.div>
       </Condition>
      </AnimatePresence>
    </Box>
  );
};

export default Accordion;
